import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomValidatorsComponent } from './custom-validators.component';
import { CustomValidatorsRoutingModule } from './custom-validators-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CustomValidatorsRoutingModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [CustomValidatorsComponent],
  exports: [CustomValidatorsComponent],
})
export class CustomValidatorsModule { }



// WEBPACK FOOTER //
// ./src/app/pages/A2-utils/custom-validators/custom-validators.module.ts